import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";


import './index.css';
import App from './App';
import StError from './pages/StError';
import StContactUs from './pages/StContactUs';
import StBlogHome from './pages/StBlogsHome';

import StBlogs from "./pages/StBlogs";
import StDocs from "./pages/docs/StDocs";
import StAgency from './pages/StAgency';
import St404 from './pages/St404';
import StQuotaExceeded from './pages/StQuotaExceeded';
import StFeaturePage from './pages/features/StFeaturePage';

// Setup the router for the website
const turboRouter = createBrowserRouter(
  [
    {
      errorElement: <StError />,

      children: [
        {
          path: "/",
          element: <App />,
          errorElement: <StError />
        },
        {
          path: "/contactus",
          element: <StContactUs />,
          errorElement: <StError />
        },
        {
          path: "/blogs/*",
          element: <StBlogs />,
          errorElement: <StError />
        },
        {
          path: "/docs/*",
          element: <StDocs />,
          errorElement: <StError />
        },
        {
          path: "/developers-and-agencies",
          element: <StAgency />,
          errorElement: <StError />
        },
        {
          path: "/features/:featureSlug",
          element: <StFeaturePage />,
          errorElement: <StError />
        },
        {
          path: "/not-found",
          element: <St404 />,
          errorElement: <StError />
        },
        {
          path: "/under-construction",
          element: <StQuotaExceeded />,
          errorElement: <StError />
        }
      ]

    }

  ]

);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={turboRouter} />
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
